import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
	error: null,
	loading: true,
	areaMaps: null,
	areaMap: null,
	areaMapLoading: null,
};

export const getAreaMapDetails = createAsyncThunk(
	"areaMaps/details",
	async ({ organiserID, eventID, language, id }) => {
		const REACT_APP_API_URL = process.env.REACT_APP_API_URL;
		const REACT_APP_ENV = process.env.REACT_APP_ENV;
		const REACT_APP_API_URL_TEST = process.env.REACT_APP_API_URL_TEST;

		try {
			const baseUrl =
				REACT_APP_ENV === "prod" ? REACT_APP_API_URL : REACT_APP_API_URL_TEST;
			let url = `${baseUrl}/api/maps/public/getById/${organiserID}/${eventID}/${id}/${language}`;

			const res = await axios({
				method: "get",
				url: url,
				headers: {
					"Content-Type": "application/json",
				},
			});
			return res.data;
		} catch (error) {
			throw new Error("Bir Hata Oluştu: Get detail area maps");
		}
	}
);

export const getAreaMaps = createAsyncThunk(
	"areaMaps/getAll",
	async ({ organiserID, eventID, language }) => {
		const REACT_APP_API_URL = process.env.REACT_APP_API_URL;
		const REACT_APP_ENV = process.env.REACT_APP_ENV;
		const REACT_APP_API_URL_TEST = process.env.REACT_APP_API_URL_TEST;

		try {
			const baseUrl =
				REACT_APP_ENV === "prod" ? REACT_APP_API_URL : REACT_APP_API_URL_TEST;

			let url = `${baseUrl}/api/maps/public/${organiserID}/${eventID}/${language}`;

			const res = await axios({
				method: "get",
				url: url,
				headers: {
					"Content-Type": "application/json",
				},
			});
			return Array.isArray(res.data)
				? res.data
				: res?.data?.areaMaps || res?.data?.maps || [];
		} catch (error) {
			throw new Error("Bir Hata Oluştu: Get all area maps");
		}
	}
);

export const areaMapsSlice = createSlice({
	name: "areaMaps",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(getAreaMaps.pending, (state) => {
				state.loading = true;
				state.error = null;
			})
			.addCase(getAreaMaps.fulfilled, (state, action) => {
				state.loading = false;
				state.error = null;
				state.areaMaps = action.payload;
			})
			.addCase(getAreaMaps.rejected, (state, action) => {
				state.loading = false;
				state.error = action.error.message;
			})

			// area map details
			.addCase(getAreaMapDetails.pending, (state) => {
				state.areaMapLoading = true;
				state.error = false;
				state.areaMap = null;
			})

			.addCase(getAreaMapDetails.fulfilled, (state, action) => {
				state.areaMapLoading = null;
				state.error = false;
				state.areaMap = action.payload;
			})

			.addCase(getAreaMapDetails.rejected, (state, action) => {
				state.areaMapLoading = null;
				state.error = action.error.message;
				state.areaMap = null;
			});
	},
});

export default areaMapsSlice.reducer;
